(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vf-xmas-listing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vf-xmas-listing')) {
    class VfXmasListing extends HTMLElement {
      connectedCallback() {
        this.buttons = [...this.querySelectorAll('.vf-xmas-listing__price')];
        this.items = [...this.querySelectorAll('.product-grid__item')];
        this.count = this.querySelector('.vf-xmas-listing__count');
        this.empty = this.querySelector('.vf-xmas-listing__empty');
        if (!this.buttons.length) return;

        this.buttons.forEach((button) => {
          // Ranges without any product are shown but not clickable.
          if (this.matching(button).length === 0) button.disabled = true;
          button.addEventListener('click', () => this.apply(button));
        });
        this.updateCount(this.items.length);
      }

      matching(button) {
        const min = Number(button.dataset.min || 0);
        const max = button.dataset.max === '' ? Infinity : Number(button.dataset.max);
        return this.items.filter((item) => {
          const price = Number(item.dataset.price);
          return price >= min && price < max;
        });
      }

      apply(button) {
        const visible = new Set(this.matching(button));
        this.items.forEach((item) => {
          item.hidden = !visible.has(item);
        });
        this.buttons.forEach((b) => {
          const active = b === button;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-pressed', String(active));
        });
        if (this.empty) this.empty.hidden = visible.size > 0;
        this.updateCount(visible.size);
      }

      updateCount(n) {
        if (this.count) this.count.textContent = `${n} ${n === 1 ? 'Produkt' : 'Produkte'}`;
      }
    }
    customElements.define('vf-xmas-listing', VfXmasListing);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vf-xmas-pill-nav"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vf-xmas-pill-nav')) {
    class VfXmasPillNav extends HTMLElement {
      connectedCallback() {
        this.links = [...this.querySelectorAll('[data-target]')];
        this.bar = this.querySelector('.vf-xmas-pills__bar');
        this.barList = this.querySelector('.vf-xmas-pills__bar-list');
        this.grid = this.querySelector('.vf-xmas-pills__grid');
        if (!('IntersectionObserver' in window)) return;

        const ids = [...new Set(this.links.map((link) => link.dataset.target))];
        const targets = ids.map((id) => document.getElementById(id)).filter(Boolean);

        this.spy = new IntersectionObserver(
          (entries) => {
            const visible = entries.filter((entry) => entry.isIntersecting);
            if (!visible.length) return;
            visible.sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
            this.setActive(visible[0].target.id);
          },
          { rootMargin: '-35% 0px -55% 0px' }
        );
        targets.forEach((target) => this.spy.observe(target));

        if (this.bar && this.grid) {
          // Show the slim bar only once the tiles are above the viewport.
          this.barObserver = new IntersectionObserver(([entry]) => {
            const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.bar.classList.toggle('is-visible', show);
            this.bar.setAttribute('aria-hidden', String(!show));
            this.bar.querySelectorAll('a').forEach((a) => (show ? a.removeAttribute('tabindex') : a.setAttribute('tabindex', '-1')));
          });
          this.barObserver.observe(this.grid);
        }
      }

      disconnectedCallback() {
        this.spy?.disconnect();
        this.barObserver?.disconnect();
      }

      setActive(id) {
        this.links.forEach((link) => {
          const active = link.dataset.target === id;
          link.classList.toggle('is-active', active);
          if (active) {
            link.setAttribute('aria-current', 'true');
          } else {
            link.removeAttribute('aria-current');
          }
          // Keep the active link visible in the horizontally scrolling bar
          // without moving the page itself.
          if (active && this.barList && this.barList.contains(link)) {
            const item = link.parentElement;
            const start = item.offsetLeft - this.barList.offsetLeft;
            const end = start + item.offsetWidth;
            if (start < this.barList.scrollLeft || end > this.barList.scrollLeft + this.barList.clientWidth) {
              this.barList.scrollTo({ left: start - 16, behavior: 'smooth' });
            }
          }
        });
      }
    }
    customElements.define('vf-xmas-pill-nav', VfXmasPillNav);
  }

  } catch(e) { console.error(e); }
})();
})();
